export * from './header-pagination.module';
export * from './header-pagination.component';
